import React, { useEffect, useMemo, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import moment from "moment-timezone";
import lodash from "lodash";
import axios from "axios";
import { ProgressBar, Overlay, Tooltip } from "react-bootstrap";
import config from "../config";
import Info from "../assets/SVG/buttons/info-icon.svg";
import History from "../assets/SVG/buttons/History-button.svg";
import Profile from "../assets/SVG/icons/Avatar.svg";
import TestButton from "../assets/SVG/buttons/Test-button.svg";
import "../styles/homepage.css";
import "../styles/homepagemobile.css";
import VerifyNotification from "./VerifyNotification";
import BaseNotification from "../components/BaseNotification";
import { getUserStatusV2, getAffiliateAcByIdV2 } from "../api";
import { trackHomePage } from "../utils/mixpanel";
import { Modal, Button } from "react-bootstrap";
import * as action from "../actions";
import useCalendar from "../hooks/useCalendar";
import useTitle from "../hooks/useTitle";
import useNotification from "../hooks/useNotification";
import { initFaceMesh } from "../utils/covid/TestPageUtil";
import { detectFaces } from "../utils/covid/faceLandmarker";
axios.defaults.withCredentials = true;

const HomePageMobile = () => {
  useTitle("Home Mobile");

  const user = useSelector((state) => state.user);
  const history = useHistory();
  const { subscribe } = useNotification();

  const negativeRef = useRef(null);
  const positiveRef = useRef(null);
  const cardioRef = useRef(null);

  const [isLoading, setLoading] = useState(true);
  const [openVerify, setOpenVerify] = useState(!user?.verified);
  const [hasPlanUsageLimit, setHasPlanUsageLimit] = useState(false);
  const [showTestButton, setShowTestButton] = useState(true);

  // Test States

  const [testResults, setTestResults] = useState([]);

  // UserStatus State
  const [userStatusState, setUserStatusState] = useState({});
  const [totalTestCounts, setTotalTestCounts] = useState();
  const [weekTestResults, setWeekTestResults] = useState();
  const [monthTestResults, setMonthTestResults] = useState();
  const [alerts, setAlerts] = useState();
  const [subscriptions, setSubscriptions] = useState();
  const [activeCovidSub, setActiveCovidSub] = useState();
  const [activeCardioSub, setActiveCardioSub] = useState();
  const [activeOneTimeCovid, setActiveOneTimeCovid] = useState();
  const [testCovidCounts, setTestCovidCounts] = useState();
  const [testLimitByCurrentSubscription, setTestLimitByCurrentSubscription] = useState();
  const [totalCovidTestCount, setTotalCovidTestCount] = useState();
  const [maxTestCovidByPlan, setMaxTestCovidByPlan] = useState(0);
  const [totalCardioTestCount, setTotalCardioTestCount] = useState();
  const [maxTestCardioByPlan, setMaxTestCardioByPlan] = useState("Unlimited");
  const [covidTrialTestLimit, setCovidTrialTestLimit] = useState(0);
  const [cardioTrialTestLimit, setCardioTrialTestLimit] = useState(0);
  const [totalTestLimitByPlan, setTotalTestLimitByPlan] = useState();

  // Test counts
  const [testCounts, setTestCounts] = useState({
    count_negative: 0,
    count_positive: 0,
    count_cardio: 0,
  });
  const [lastCovidTest, setLastCovidTest] = useState(null);

  const [showTooltip, setShowTooltip] = useState({
    showNegative: false,
    showPositive: false,
    showCardio: false,
  });

  const [testCountsByPeriod, setTestCountsByPeriod] = useState({
    count_negative: 0,
    count_positive: 0,
  });

  //Affiliate States
  const [affiliateProducts, setAffiliateProducts] = useState();

  const { calendarData, weekFrom, weekTo, monthFrom, monthTo, getCalendarWeek } = useCalendar();

  const calendar = () => {
    return calendarData.days.map((day, index) => {
      return (
        <div className="date" key={index}>
          {day}
          {testResults[calendarData.dates[index]] === undefined || testResults[calendarData.dates[index]] === null ? (
            <span>
              {calendarData.dates[index]}{" "}
              {calendarData.today_date === calendarData.dates[index] && <span className="dot"></span>}
            </span>
          ) : testResults[calendarData.dates[index]].type == "Positive" ? (
            <span className="red-border">
              {calendarData.dates[index]}{" "}
              {calendarData.today_date === calendarData.dates[index] && <span className="dot"></span>}
            </span>
          ) : testResults[calendarData.dates[index]].type == "Negative" ? (
            <span className="green-border">
              {calendarData.dates[index]}{" "}
              {calendarData.today_date === calendarData.dates[index] && <span className="dot"></span>}
            </span>
          ) : (
            <span className="cardio-border">
              {calendarData.dates[index]}{" "}
              {calendarData.today_date === calendarData.dates[index] && <span className="dot"></span>}
            </span>
          )}
        </div>
      );
    });
  };

  const getAffiliateProducts = async () => {
    if (user?.affiliateLinkId) {
      const getAffiliateAcByAffLinkIdResp = await getAffiliateAcByIdV2(user?.affiliateLinkId);
      setAffiliateProducts(getAffiliateAcByAffLinkIdResp?.affiliateLink?.productCoupons);
    }
  };

  const _showTestButton = (user, userStatus) => {
    if (user.accountType === "trial_expired") {
      setShowTestButton(false);
    }
    if (user.accountType === "canceled") {
      setShowTestButton(false);
    }
  };

  const checkStatus = async () => {
    setLoading(true);
    console.log("getUserStatusV2");
    const userStatus = await getUserStatusV2({
      uid: user.uid,
      accountType: user.accountType,
      affiliateLinkId: user.affiliateLinkId,
      weekFrom,
      weekTo,
      monthFrom,
      monthTo,
    });

    // Setting States
    setUserStatusState(userStatus);
    setTestCountsByPeriod(userStatus?.testCounts)
    setTotalTestCounts(userStatus?.totalTestCounts);
    setWeekTestResults(userStatus?.weekTestResults);
    setMonthTestResults(userStatus?.monthTestResults);
    setAlerts(userStatus?.alerts);
    setSubscriptions(userStatus?.subscriptions);
    setActiveCovidSub(userStatus?.activeCovidSub);
    setActiveCardioSub(userStatus?.activeCardioSub);
    setActiveOneTimeCovid(userStatus?.activeOneTimeCovid);
    setTestCovidCounts(userStatus?.testCovidCounts);
    setTestLimitByCurrentSubscription(userStatus?.testLimitByCurrentSubscription);
    setTotalCovidTestCount(userStatus?.totalCovidTestCount);
    setMaxTestCovidByPlan(
      parseInt(userStatus?.activeCovidSub?.usageLimit?.testLimit?.unit) *
        parseInt(userStatus?.activeCovidSub?.usageLimit?.testLimit?.interval_count)
    );
    setTotalCardioTestCount(userStatus?.totalCardioTestCount);
    const testLimitByPlan = userStatus.testLimitByPlan;
    setTotalTestLimitByPlan(testLimitByPlan);
    setCovidTrialTestLimit(
      user?.affiliateAccount?.covidTrialTestLimit === undefined
        ? user?.covidTrialTestLimit
        : user?.affiliateAccount?.covidTrialTestLimit
    );
    setCardioTrialTestLimit(
      user?.affiliateAccount?.cardioTrialTestLimit === undefined
        ? user?.cardioTrialTestLimit
        : user?.affiliateAccount?.cardioTrialTestLimit
    );

    _showTestButton(user, userStatus);

    const { weekTestResults, monthTestResults } = userStatus;
    if (weekTestResults) await getResultsOfWeek(weekTestResults.covidTests, weekTestResults.cardioTests);
    if (monthTestResults) await getResultsOfMonth(monthTestResults.covidTests, monthTestResults.cardioTests);

    setLoading(false);
  };

  const getResultsOfWeek = async (covidTestResults, cardioTestResults) => {
    let test_results = {};

    for (let i = covidTestResults.length - 1; i >= 0; i--) {
      let isCovid = null;
      if (covidTestResults[i].covid_status === "Negative") {
        isCovid = "Negative";
      } else if (covidTestResults[i].covid_status === "Positive") {
        isCovid = "Positive";
      }

      let date = moment(covidTestResults[i].createdAt)
        .tz(user.timezone || config.defaultTimezone)
        .format("DD");

      if (test_results[date]) {
        const exist = moment(test_results[date].date);
        const current = moment(covidTestResults[0].createdAt);
        if (exist.diff(current) < 0) {
          test_results[date] = {
            type: isCovid,
            date: covidTestResults[i].createdAt,
          };
        }
      } else {
        test_results[date] = {
          type: isCovid,
          date: covidTestResults[i].createdAt,
        };
      }
    }

    for (let i = cardioTestResults.length - 1; i >= 0; i--) {
      let date = moment(cardioTestResults[i].createdAt)
        .tz(user.timezone || config.defaultTimezone)
        .format("DD");
      if (test_results[date]) {
        const exist = moment(test_results[date].date);
        const current = moment(cardioTestResults[0].createdAt);
        if (exist.diff(current) < 0) {
          test_results[date] = {
            type: "Cardio",
            date: cardioTestResults[i].createdAt,
          };
        }
      } else {
        test_results[date] = {
          type: "Cardio",
          date: cardioTestResults[i].createdAt,
        };
      }
    }

    setTestResults(test_results);
  };

  const getResultsOfMonth = async (covidTestResults, cardioTestResults) => {
    let count_positive = 0,
      count_negative = 0,
      count_cardio = 0,
      last_covid_test;

    for (let i = 0; i < covidTestResults.length; i++) {
      if (covidTestResults[i].covid_status === "Negative") {
        count_negative++;
      } else if (covidTestResults[i].covid_status === "Positive") {
        count_positive++;
      }
    }

    count_cardio = cardioTestResults.length;

    if (covidTestResults.length > 0 && cardioTestResults.length > 0) {
      const covidLastDay = moment(covidTestResults[0].createdAt);
      const cadioLastDay = moment(cardioTestResults[0].createdAt);
      if (covidLastDay.diff(cadioLastDay) > 0) {
        last_covid_test = covidTestResults[0].createdAt;
      } else {
        last_covid_test = cardioTestResults[0].createdAt;
      }
    } else if (covidTestResults.length > 0 && cardioTestResults.length == 0) {
      last_covid_test = covidTestResults[0].createdAt;
    } else if (covidTestResults.length == 0 && cardioTestResults.length > 0) {
      last_covid_test = cardioTestResults[0].createdAt;
    }

    setTestCounts({
      count_negative,
      count_positive,
      count_cardio,
    });
    setLastCovidTest(last_covid_test);
  };

  useEffect(() => {
    checkStatus();
    getCalendarWeek();
    subscribe();
    getAffiliateProducts();
    if (user?.uid) {
      if (!user?.hasRevenueCatSub) {
        history.push("/home");
      }
      trackHomePage(user.uid);
    }
  }, []);

  // Initiate Vision Task
  useEffect(() => {
    const MAX_RESOLUTION_WIDTH = 2500;
    initFaceMesh().then(async (_faceLandmarker) => {
      // Initiating Facemesh to buffer the initialization.

      const iniDummyCanvas = document.createElement("canvas");
      const _MAX_RESOLUTION_WIDTH = MAX_RESOLUTION_WIDTH / 2; // Making smaller max resolution for dummy init for detecting face.
      iniDummyCanvas.width = _MAX_RESOLUTION_WIDTH;
      iniDummyCanvas.height = (_MAX_RESOLUTION_WIDTH * 4) / 3;

      const ctx = iniDummyCanvas.getContext("2d");
      ctx.fillRect(0, 0, _MAX_RESOLUTION_WIDTH, (_MAX_RESOLUTION_WIDTH * 4) / 3);
      ctx.imageSmoothingEnabled = false;
      const predictions = await detectFaces(iniDummyCanvas);
      console.log("init home predictions", predictions);
    });
  }, []);

  const labels = useMemo(() => {
    if (user?.accountType === "trial" && !!testCounts) {
      return {
        count_negative: testCounts.count_negative,
        count_positive: testCounts.count_positive,
        count_cardio: testCounts.count_cardio,
        count_negative_percentage:
          (testCounts.count_negative * 100) /
            ((user.cardio_access ? cardioTrialTestLimit : 0) + (user.covid_access ? covidTrialTestLimit : 0)) ?? 0,
        count_positive_percentage:
          (testCounts.count_positive * 100) /
            ((user.cardio_access ? cardioTrialTestLimit : 0) + (user.covid_access ? covidTrialTestLimit : 0)) ?? 0,
        count_cardio_percentage:
          (testCounts.count_cardio * 100) /
            ((user.cardio_access ? cardioTrialTestLimit : 0) + (user.covid_access ? covidTrialTestLimit : 0)) ?? 0,
      };
    } else if ((user?.accountType === "active" || user.accountType === "canceled") && !!testCountsByPeriod) {
      return {
        count_negative: testCountsByPeriod.count_negative,
        count_positive: testCountsByPeriod.count_positive,
        count_cardio: testCounts.count_cardio,
        count_negative_percentage: (testCountsByPeriod.count_negative * 100) / maxTestCovidByPlan ?? 0,
        count_positive_percentage: (testCountsByPeriod.count_positive * 100) / maxTestCovidByPlan ?? 0,
        count_cardio_percentage: (testCounts.count_cardio * 100) / maxTestCovidByPlan,
      };
    } else if (user?.accountType === "free" && !!testCounts) {
      return {
        count_negative: testCounts.count_negative,
        count_positive: testCounts.count_positive,
        count_cardio: testCounts.count_cardio,
        count_negative_percentage: (testCounts.count_negative * 100) / 100 ?? 0,
        count_positive_percentage: (testCounts.count_positive * 100) / 100 ?? 0,
        count_cardio_percentage: (testCounts.count_cardio * 100) / 100 ?? 0,
      };
    }

    return {
      count_negative: "",
      count_positive: "",
      count_cardio: "",
      count_negative_percentage: 0,
      count_positive_percentage: 0,
      count_cardio_percentage: 0,
    };
  }, [
    user.accountType,
    testCounts,
    testCountsByPeriod,
    totalTestLimitByPlan,
    cardioTrialTestLimit,
    covidTrialTestLimit,
  ])
  const _getActiveProduct = (activeCovidSub, activeCardioSub) => {
    if (lodash.isEmpty(activeCovidSub) && lodash.isEmpty(activeCardioSub)) {
      return "No active subscriptions";
    }
    if (!lodash.isEmpty(activeCovidSub) && !lodash.isEmpty(activeCardioSub)) {
      return `${activeCovidSub?.product?.name} & ${activeCardioSub?.product?.name}`;
    }
    if (!lodash.isEmpty(activeCovidSub) && lodash.isEmpty(activeCardioSub)) {
      return activeCovidSub?.product?.name;
    }
    if (lodash.isEmpty(activeCovidSub) && !lodash.isEmpty(activeCardioSub)) {
      return activeCardioSub?.product?.name;
    }
  };
  const accountStatus = (user, activeCovidSub, activeCardioSub) => {
    // Free user
    switch (user.accountType) {
      case "trial": {
        return (
          <div className="account-type" data-testid="trial-account-label">
            Your are on a trial account.
          </div>
        );
      }
      case "free": {
        return (
          <div className="account-type" data-testid="free-account-label">
            Your are on a free account.
          </div>
        );
      }
      case "canceled": {
        return (
          <div className="account-type">
            <span className="canceled-plan-label">Active plan: No any active plans</span>
          </div>
        );
      }
      case "trial_expired": {
        return (
          <div className="account-type-trial-expired">
            Your trial has ended. Please upgrade your account to continue running tests.
          </div>
        );
      }
      case "pending_cancel":
      case "active": {
        return (
          <>
            <div className="account-type">
              Active plan:{" "}
              <span className="active-product-name">{_getActiveProduct(activeCardioSub, activeCovidSub)}</span>
            </div>
            {(activeCovidSub || activeCardioSub) && <div className="account-type-remaining">Remaining Test</div>}
            {activeCovidSub && (
              <div className="account-type-remaining">
                Covid: {parseInt(maxTestCovidByPlan) - parseInt(totalCovidTestCount)} out of {maxTestCovidByPlan}
              </div>
            )}
            {activeCardioSub && <div className="account-type-remaining">Cardio: {maxTestCardioByPlan}</div>}
          </>
        );
      }
    }
  };
  return (
    <>
      {/* Account verify sticky */}
      {openVerify && <VerifyNotification closeNotification={() => setOpenVerify(false)} />}

      {/* Max number of Usage */}
      {hasPlanUsageLimit && (
        <BaseNotification
          ctaText="Go to Plan"
          notificationMessage="You reached the maximum number of tests"
          onClickCta={() => history.push("/plans")}
          customStyle={{ background: "red !important" }}
        />
      )}
      <div className="container" data-testid="homepage-mobile-container">
        {isLoading && <div id="homepage-loading" data-testid="homepage-loading"></div>}

        <div className="main home mt-3">
          <div className="heading">Hi {user.firstName}!</div>
          <p>Ready to enjoy a lively day?</p>
          <div className="header">
            <img
              src={History}
              alt="history"
              onClick={() => history.push("/testhistory")}
              className="gotoHistory"
              data-testid="gotoHistory"
            ></img>
            <img
              src={user.picture ? user.picture : Profile}
              alt="profile"
              className="mt-4 profile"
              onClick={() => history.push("/navigation")}
              data-testid="gotoNavigation"
            ></img>
            <img src={Info} alt="info" onClick={() => history.push("/info")} data-testid="gotoInfo"></img>
          </div>
          <div className="progressbar">
            <div className="account-type-container-mobile">{accountStatus(user, activeCovidSub, activeCardioSub)}</div>
            <div className="above-progress mt-2">
              {/* <p className="text-left">Total number of completed tests since the start of the month</p> */}
              {lastCovidTest && (
                <p className="text-right gray-color">
                  Last Test Day:{" "}
                  {moment(lastCovidTest)
                    .tz(user.timezone || config.defaultTimezone)
                    .format("YYYY-MM-DD")}
                </p>
              )}
            </div>
            <ProgressBar>
              <Overlay target={negativeRef.current} show={showTooltip.showNegative} placement="top">
                {(props) => (
                  <Tooltip id="tooltip-negative" {...props}>
                    COVID high risk: <strong>{labels.count_negative}</strong> Tests
                  </Tooltip>
                )}
              </Overlay>
              <Overlay target={positiveRef.current} show={showTooltip.showPositive} placement="top">
                {(props) => (
                  <Tooltip id="tooltip-positive" {...props}>
                    COVID low risk: <strong>{labels.count_positive}</strong> Tests
                  </Tooltip>
                )}
              </Overlay>
              <Overlay target={cardioRef.current} show={showTooltip.showCardio} placement="top">
                {(props) => (
                  <Tooltip id="tooltip-cardio" {...props}>
                    Cardio: <strong>{labels.count_cardio}</strong> Tests
                  </Tooltip>
                )}
              </Overlay>
              <ProgressBar
                ref={negativeRef}
                onMouseLeave={() => setShowTooltip({ showNegative: false, showPositive: false, showCardio: false })}
                onMouseEnter={() => setShowTooltip({ showNegative: true, showPositive: false, showCardio: false })}
                variant="success"
                now={labels.count_negative_percentage}
                key={1}
              />
              <ProgressBar
                ref={positiveRef}
                onMouseLeave={() => setShowTooltip({ showNegative: false, showPositive: false, showCardio: false })}
                onMouseEnter={() => setShowTooltip({ showNegative: false, showPositive: true, showCardio: false })}
                variant="danger"
                now={labels.count_positive_percentage}
                key={2}
              />
              <ProgressBar
                ref={cardioRef}
                onMouseLeave={() => setShowTooltip({ showNegative: false, showPositive: false, showCardio: false })}
                onMouseEnter={() => setShowTooltip({ showNegative: false, showPositive: false, showCardio: true })}
                className="cardio-bar"
                now={labels.count_cardio_percentage}
                key={3}
              />
            </ProgressBar>
            <p className="month mt-2">
              {calendarData.weekEnd_month === calendarData.weekStart_month
                ? calendarData.weekStart_month + " " + calendarData.year
                : calendarData.weekStart_month + "-" + calendarData.weekEnd_month + " " + calendarData.year}
            </p>
            <div className="calender blue-text">{calendar()}</div>
          </div>
          <div className="alert">
            <div className="view-reminders">
              <p className="white-color font-size-12">Alerts</p>
              <p
                data-testid="alert-view-all-btn"
                className="gray-color text-underline font-size-12 view-all"
                onClick={() => history.push("/alerts")}
              >
                View all
              </p>
            </div>
            {lodash.isEmpty(alerts) && <p>No alerts to show</p>}
            {alerts &&
              alerts.map((alert) => {
                return (
                  <div
                    className="alert-card"
                    data-testid={`alert-${alert._id}`}
                    key={alert._id}
                    onClick={() => history.push(`/alerts/${alert._id}`)}
                  >
                    <div className="alert-card-head">
                      <div className="card-date">
                        <div className={`grey-circle ${alert.status}`}></div>
                        <div className="card-date-timestamp">
                          <div className="alert-card-month-day">
                            {moment(alert.createdAt)
                              .tz(user.timezone || config.defaultTimezone)
                              .format("MMM DD")}
                          </div>
                          <div className="alert-card-time">
                            {moment(alert.createdAt)
                              .tz(user.timezone || config.defaultTimezone)
                              .format("LT")}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="alert-card-body">
                      <div className="alert-card-body-title">{alert?.title}</div>
                      <div className="alert-card-body-short-message">{alert?.shortMessage}</div>
                    </div>
                  </div>
                );
              })}
          </div>
          {showTestButton && (
            <div className="buttons-div">
              <div className="button">
                <img
                  src={TestButton}
                  alt="start-test"
                  width="100px"
                  height="100px"
                  onClick={() => history.push("/testSelection")}
                  data-testid="gotoTestSelection"
                />
                <span>Start</span>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default HomePageMobile;
